module.exports = __webpack_public_path__ + "static/media/icon-left.0ea4be34.svg";